import React, { useState } from "react";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import NewsPage from "./pages/NewsPage";
import ReportsPage from "./pages/ReportsPage";
import CivilStatusPage from "./pages/CivilStatusPage";
import EventsPage from "./pages/EventsPage";
import UsersPage from "./pages/UsersPage";
import NotificationsPage from "./pages/NotificationsPage";
import StatsPage from "./pages/StatsPage";
import UrbanPage from "./pages/UrbanPage";
import DirectoryPage from "./pages/DirectoryPage";
import PaymentsPage from "./pages/PaymentsPage";
import Header from "./components/Header";

const menuItems = [
  { id: "dashboard", label: "Tableau de bord" },
  { id: "news", label: "Actualites" },
  { id: "reports", label: "Signalements" },
  { id: "civil", label: "Etat Civil" },
  { id: "events", label: "Evenements" },
  { id: "urban", label: "Urbanisme" },
  { id: "directory", label: "Annuaire" },
  { id: "payments", label: "Paiements" },
  { id: "users", label: "Utilisateurs" },
  { id: "notifications", label: "Notifications" },
  { id: "stats", label: "Statistiques" },
];

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("access_token"));
  const [currentPage, setCurrentPage] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  if (!isLoggedIn) return <LoginPage onLogin={() => setIsLoggedIn(true)} />;

  const pages = {
    dashboard: <DashboardPage />,
    news: <NewsPage />,
    reports: <ReportsPage />,
    civil: <CivilStatusPage />,
    events: <EventsPage />,
    urban: <UrbanPage />,
    directory: <DirectoryPage />,
    payments: <PaymentsPage />,
    users: <UsersPage />,
    notifications: <NotificationsPage />,
    stats: <StatsPage />,
  };

  return (
    <div style={{ display: "flex", height: "100vh", fontFamily: "Poppins, sans-serif", backgroundColor: "#F5F6FA" }}>
      <div style={{ width: sidebarOpen ? 240 : 0, background: "linear-gradient(180deg, #0F3D1A, #1A5C2A)", display: "flex", flexDirection: "column", overflow: "hidden", transition: "width 0.2s", flexShrink: 0 }}>
        {sidebarOpen && (
          <>
            <div style={{ padding: "24px 20px", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 40, height: 40, background: "rgba(255,255,255,0.2)", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
                </div>
                <div>
                  <div style={{ color: "white", fontWeight: 800, fontSize: 14 }}>Bot-Makak</div>
                  <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 11 }}>Administration</div>
                </div>
              </div>
            </div>
            <nav style={{ flex: 1, padding: "16px 12px", overflowY: "auto" }}>
              {menuItems.map(item => (
                <button key={item.id} onClick={() => setCurrentPage(item.id)}
                  style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "12px 16px", borderRadius: 12, border: "none", cursor: "pointer", marginBottom: 4, background: currentPage === item.id ? "rgba(255,255,255,0.2)" : "transparent", color: "white", fontSize: 14, fontWeight: currentPage === item.id ? 600 : 400, fontFamily: "Poppins", textAlign: "left" }}>
                  {item.label}
                </button>
              ))}
            </nav>
            <div style={{ padding: "16px 20px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
              <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 11, textAlign: "center" }}>Bot-Makak Platform v1.0</div>
            </div>
          </>
        )}
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} onLogout={() => { localStorage.clear(); setIsLoggedIn(false); }} />
        <main style={{ flex: 1, overflow: "auto", padding: "24px" }}>
          {pages[currentPage]}
        </main>
      </div>
    </div>
  );
}
